export var DealExtractors = {
    id: function (u) { return u.id; },
    name: function (u) { return u.name; },
    color: function (u) { return u.color; },
};
